import { AtTextFieldProps } from "./at-text-field.types";
import { TextField } from "@mui/material";
import { GlobalTextFieldStyles } from "../../../theme/global-styles";
import { capitalize } from "../../../utils/capitalize";

export const AtTextField = ({
  label,
  required,
  onChange,
  disabled,
  error,
  value,
  helpText,
  autoCapitalization,
  type = "text",
  autoComplete,
}: AtTextFieldProps) => {
  const handleChange = (value: string) => {
    const formattedValue = autoCapitalization ? capitalize(value) : value;
    onChange?.(formattedValue);
  };

  return (
    <>
      <GlobalTextFieldStyles />
      <TextField
        type={type}
        label={label}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        required={required}
        error={error}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        helperText={helpText as any}
        size="small"
        variant="outlined"
        fullWidth
        autoComplete={autoComplete}
      />
    </>
  );
};
